// ✅ Dùng type-only import khi bật verbatimModuleSyntax
import type { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios'
import axios from 'axios'

// Token nội bộ
let token: string | null = null

// ✅ Tạo instance Axios chuẩn
const APIClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://dummyjson.com',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// ✅ Request Interceptor
APIClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const fcmToken = localStorage.getItem('__on-fcm-token')
    config.headers.set('_X-FCM-TOKEN', `${fcmToken}`)
    if (token && config.headers) {
      config.headers.set('Authorization', `Bearer ${token}`)
    }

    // ⚙️ Nếu URL là đầy đủ (full URL), bỏ qua baseURL bằng cách gán thẳng
    if (config.url && /^https?:\/\//i.test(config.url)) {
      config.baseURL = ''
    }

    return config
  },
  (error: AxiosError): Promise<never> => {
    return Promise.reject(error)
  }
)

// ✅ Response Interceptor với kiểm tra an toàn
APIClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError): Promise<never> => {
    const status = error.response?.status
    const data = error.response?.data as { message?: string } | undefined
    const message = data?.message || error.message || 'Unknown error'

    switch (status) {
      case 401:
        console.error('🔒 Unauthorized:', message)
        window.dispatchEvent(new Event('unauthorized'))
        break
      case 403:
        console.error('⛔ Forbidden:', message)
        break
      case 500:
        console.error('💥 Server error:', message)
        break
      default:
        console.error('⚠️ API Error:', message)
    }

    return Promise.reject(error)
  }
)

// ✅ Method control (không dùng any, dùng generic cụ thể)
export const setToken = (newToken: string): void => {

  token = newToken
}

export const clearToken = (): void => {
  token = null
}

export const overrideMethod = <K extends keyof AxiosInstance>(
  method: K,
  fn: AxiosInstance[K]
): void => {
  ;(APIClient as AxiosInstance)[method] = fn
}

// ✅ Named export là chuẩn, dễ tree-shake hơn default
export { APIClient }
